// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const TOGGLE_USER_STATUS = 'TOGGLE_USER_STATUS';
export const TOGGLE_ORDER_STATUS = 'TOGGLE_ORDER_STATUS';
export const UPDATE_SERVER_STATUS = 'UPDATE_SERVER_STATUS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const SET_STOCKS = 'SET_STOCKS';
export const SET_TICKS = 'SET_TICKS';
export const SET_PNL = 'SET_PNL';
export const SET_KITE_CONNECT_STATUS = 'SET_KITE_CONNECT_STATUS';
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS';
export const SET_STOCK_GROUP = 'SET_STOCK_GROUP';
export const SET_STRATEGIES_BACK_TESTING = 'SET_STRATEGIES_BACK_TESTING';
export const SET_STRATEGIES_LIVE_TRADE = 'SET_STRATEGIES_LIVE_TRADE';
export const SET_STRATEGIES = 'SET_STRATEGIES';
export const SET_USER_ACCOUNT = 'SET_USER_ACCOUNT';
export const SET_LOGGED_IN_USER_IDS = 'SET_LOGGED_IN_USER_IDS';
export const SET_IS_ADVANCED = 'SET_IS_ADVANCED';
export const TOGGLE_ORDER_REQUEST_STATUS = 'TOGGLE_ORDER_REQUEST_STATUS';
export const SET_PREPARE_DATA_PROGRESS = 'SET_PREPARE_DATA_PROGRESS';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_SERVER_HEALTH_DATA = 'SET_SERVER_HEALTH_DATA';
export const SET_SUBSCRIBED = 'SET_SUBSCRIBED';
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';

export const SET_ORDER_PNL = 'SET_ORDER_PNL';
